// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ayiGUGYnHMowtQ0S {
	padding: var(--lok-spacing-7);
}

.RNnp1xNd4a4iHATa {
	font: var(--lok-typography-heading-3);
	font-family: var(--lok-font-family-inter);
}

.blb2HEOSSWE3GwYx {
	font: var(--lok-typography-body-small-default);
	font-family: var(--lok-font-family-inter);
}

.Yy2fWKbbArkf28VO {
	font: var(--lok-typography-body-small-strong);
	font-family: var(--lok-font-family-inter);
}

.hUekNd8iIn8fDt3u {
	height: 100%;
}

.cbkT6S1FhuEZZQH0 {
	width: 470px;
	min-height: 538px;
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/AssignmentModal/components/OverviewStep/OverviewStep.module.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,qCAAqC;CACrC,yCAAyC;AAC1C;;AAEA;CACC,8CAA8C;CAC9C,yCAAyC;AAC1C;;AAEA;CACC,6CAA6C;CAC7C,yCAAyC;AAC1C;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,iBAAiB;AAClB","sourcesContent":[".container {\n\tpadding: var(--lok-spacing-7);\n}\n\n.heading {\n\tfont: var(--lok-typography-heading-3);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.subheading {\n\tfont: var(--lok-typography-body-small-default);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.stepsContainerHeading {\n\tfont: var(--lok-typography-body-small-strong);\n\tfont-family: var(--lok-font-family-inter);\n}\n\n.footer {\n\theight: 100%;\n}\n\n.imageContainer {\n\twidth: 470px;\n\tmin-height: 538px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ayiGUGYnHMowtQ0S`,
	"heading": `RNnp1xNd4a4iHATa`,
	"subheading": `blb2HEOSSWE3GwYx`,
	"stepsContainerHeading": `Yy2fWKbbArkf28VO`,
	"footer": `hUekNd8iIn8fDt3u`,
	"imageContainer": `cbkT6S1FhuEZZQH0`
};
export default ___CSS_LOADER_EXPORT___;
